import {
    LIST_ACCOUNT_TYPE_MAPPING_SUCCESS,
    LIST_ACCOUNT_TYPE_MAPPING_FAILED,
    LOADING_LIST_ACCOUNT_TYPE_MAPPING,
    NETWORK_ERROR_LIST_ACCOUNT_TYPE_MAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const listAccountTypeMapping =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_LIST_ACCOUNT_TYPE_MAPPING });
        await adminServices
            .post("acctTypeMappingListAdmin", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: LIST_ACCOUNT_TYPE_MAPPING_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: LIST_ACCOUNT_TYPE_MAPPING_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_LIST_ACCOUNT_TYPE_MAPPING,
                    payload: err
                });
            });
    };

export { listAccountTypeMapping };
